//============================
//# Interfészek (csisynciface)
//============================

export enum Iface {
    /** Technikai rekord */
    None = 1,
    /** BMW Incadea interfész */
    Incadea = 2,
    /** Volvo cikk interfész */
    VolvoParts = 3,
    /** Volvo ár interfész */
    VolvoPrice = 4,
    /** Általános excel betöltő */
    GenericExcelImport = 5,
    /** BillCity */
    BillCity = 6,
}
